import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CalculatorCounterComponent } from '@app/modules/warehouse-mobile-app/calculator-counter/calculator-counter.component';
import { WarehouseScannerComponent } from '@app/modules/warehouse-mobile-app/warehouse-scanner/warehouse-scanner.component';
import {
  LocationWarehouseAppComponent,
  LocationWarehouseAppScannerDevicesComponent,
  LocationWarehouseAppScannerComponent,
  LocationWarehouseSelectionComponent,
  LocationWarehouseQuantityEntryComponent,
  LocationWarehouseAppSkuSelectionComponent,
  LocationWarehouseSkuTransferComponent,
} from 'v2/modules/location/components';

const routes :Routes = [
  {
    path: '',
    component: LocationWarehouseAppComponent,
  },
  {
    path: 'devices',
    component: LocationWarehouseAppScannerDevicesComponent,
  },
  {
    path: 'location-scan',
    component: LocationWarehouseAppScannerComponent,
  },
  { path: 'warehouse-scanner', component: WarehouseScannerComponent },
  {
    path: 'sku-selection/:locationId',
    component: LocationWarehouseAppSkuSelectionComponent,
  },
  {
    path: 'location-selection/:sku',
    component: LocationWarehouseSelectionComponent,
  },
  {
    path: 'transfer/bulk',
    component: LocationWarehouseSkuTransferComponent,
  },
  {
    path: 'quantity-entry/:rfq_stock_location_id',
    component: LocationWarehouseQuantityEntryComponent,
  },
  {
    path: 'transfer/from/:rfq_stock_location_id/:quantity',
    component: LocationWarehouseAppScannerComponent,
  },
  { path: 'calculator-counter', component: CalculatorCounterComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WarehouseMobileAppRoutingModule {}
